import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
import type { IconType } from 'react-icons';
import { useLocale } from '../../hooks/useLocale';

export function SettingsPageHeader({ title, icon: Icon, onBack }: { title: string; icon: IconType; onBack: () => void }) {
  const { t } = useTranslation();
  const { isRtl } = useLocale();
  return <header className="settings-page-header athlete-settings-modal__header">
    <div className="athlete-settings-modal__header-main">
      <button type="button" className="athlete-settings-modal__back-btn" onClick={onBack} aria-label={t('common.back', 'Back').replace(/[←→]/g, '').trim()}>
        {isRtl ? <IoChevronForwardOutline aria-hidden="true" /> : <IoChevronBackOutline aria-hidden="true" />}
      </button>
      <div className="athlete-settings-modal__zone-title">
        <span className="power-zone-editor__icon"><Icon aria-hidden="true" /></span>
        <h1>{title}</h1>
      </div>
    </div>
  </header>;
}
